// extracted by mini-css-extract-plugin
export default {"header":"style_header__7cw5h","title":"style_title__kCA0w","deleteButton":"style_deleteButton__bbuAM"};